import { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";

const sharedAudioContext = new AudioContext();

function Waveform({ audioUrl, wavesurferRef, onReady, isVisible }) {
  const containerRef = useRef();

  useEffect(() => {
    if (!audioUrl || !containerRef.current || !isVisible) return;

    if (wavesurferRef.current) {
      wavesurferRef.current.destroy();
    }

    const ws = WaveSurfer.create({
      container: containerRef.current,
      waveColor: '#e5e5e5',
      progressColor: '#f97316',
      height: 40,
      barWidth: 2,
      barRadius: 2,
      cursorWidth: 0,
      responsive: true,
      normalize: true,
      partialRender: true,
      backend: 'WebAudio',
      audioContext: sharedAudioContext,
      fillParent: true,
    });

    wavesurferRef.current = ws;
    ws.load(audioUrl);

    ws.on("ready", () => {
      onReady?.();
    });

    return () => {
      ws.destroy();
    };
  }, [audioUrl, wavesurferRef, onReady, isVisible]);

  return <div ref={containerRef} className="waveform-container" />;
}

export default Waveform;